import { createFileRoute, redirect } from '@tanstack/react-router'

// 假设课程页面的路由路径为 /courses
const LOGIN_PAGE_PATH = '/courses'

export const Route = createFileRoute('/')({
  loader: () => {
    // 重定向到课程页面
    return redirect({ to: LOGIN_PAGE_PATH })
  },
})
